import { B } from "../../design/tokens";
import Reveal from "../shared/Reveal";
import Tag from "../shared/Tag";

export default function CoverageSection() {
  const regions = [
    { n: "01", name: "NCR – Metro Manila",         tag: "Home Base",  desc: "Standard rates apply. RPT Basic Filing is exempt from out-of-pocket expenses." },
    { n: "02", name: "CALABARZON / Central Luzon", tag: "Regional",   desc: "Standard regional rates with estimated field expenses." },
    { n: "03", name: "Other Parts of Luzon",       tag: "Extended",   desc: "Nationwide servicing with estimated field and travel expenses." },
    { n: "04", name: "Visayas & Mindanao",          tag: "Nationwide", desc: "Full coverage including field accommodation for remote LGU engagements." },
  ];
  return (
    <section style={{ background: B.white, padding: "120px 0", borderTop: `1px solid ${B.pale}` }}>
      <div style={{ maxWidth: 1280, margin: "0 auto", padding: "0 32px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "360px 1fr", gap: 80, alignItems: "start" }} className="coverage-grid">
          <Reveal from="left">
            <Tag text="Coverage" />
            <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "clamp(32px, 3.8vw, 48px)", fontWeight: 700, color: B.navy, lineHeight: 1.1, letterSpacing: -0.5, marginBottom: 24 }}>
              Serving the Entire<br /><em style={{ color: B.azure }}>Philippines</em>
            </h2>
            <p style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 15, color: B.slate, lineHeight: 1.85, marginBottom: 28 }}>
              Whether you're in Metro Manila or a remote municipality in Mindanao — NESW is equipped to serve you wherever your property is located.
            </p>
            <div style={{ padding: "18px 22px", background: `${B.azure}0d`, border: `1px solid ${B.azure}22` }}>
              <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 10.5, color: B.azure, letterSpacing: 2, textTransform: "uppercase", fontWeight: 600, marginBottom: 7 }}>Transparency Commitment</div>
              <p style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 13.5, color: B.slate, lineHeight: 1.7 }}>All out-of-pocket expenses are estimated in advance, fully receipted, and refunded if unused.</p>
            </div>
          </Reveal>
          <div>
            {regions.map((r, i) => (
              <Reveal key={i} delay={0.1 * i}>
                <div style={{ display: "flex", gap: 24, padding: "28px 0", borderBottom: i < 3 ? `1px solid ${B.pale}` : "none", alignItems: "flex-start", transition: "padding-left 0.3s" }}
                  onMouseEnter={e => e.currentTarget.style.paddingLeft = "8px"}
                  onMouseLeave={e => e.currentTarget.style.paddingLeft = "0"}
                >
                  <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 18, fontWeight: 700, color: B.azure, flexShrink: 0, minWidth: 36, paddingTop: 2 }}>{r.n}</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 8, flexWrap: "wrap" }}>
                      <h3 style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 17, fontWeight: 700, color: B.navy }}>{r.name}</h3>
                      <span style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 11, fontWeight: 600, color: B.azure, background: `${B.azure}10`, border: `1px solid ${B.azure}22`, padding: "2px 10px", letterSpacing: 1 }}>{r.tag}</span>
                    </div>
                    <p style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 14, color: B.slate, lineHeight: 1.7 }}>{r.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
